import React from "react";

function NotFound() {
  return (
    <div>
      <h1>404 Not Found</h1>
      <p>this is not the page you are looking for...</p>
    </div>
  )
}

export default NotFound;